import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Paper,
  Typography,
  Container,
  Grid,
  Button,
  CircularProgress,
  Box,
  Link,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { EmailTextInput } from '../components/EmailTextInput';
import logo from '../static/images/logo.svg';
import '../translations/translations';
import { ApiService } from '../services/apiService';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '5rem 3rem',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '20rem',
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '2rem',
  },
  logo: {
    maxWidth: '17rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  error: {
    color: theme.palette.error.main,
    textAlign: 'right',
    fontSize: '0.8rem',
  },
  alignRight: {
    textAlign: 'right',
  },
  alignCenter: {
    textAlign: 'center',
  },
  spinner: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

const ForgotPassword = () => {
  const classes = useStyles();
  const [isDisabled, setIsDisabeld] = useState(true);
  const [confirmationSuccess, setConfirmationSuccess] = useState<
    boolean | null
  >(null);
  const [error, setError] = useState(false);

  const [username, setUsername] = useState('');

  const { t } = useTranslation(['translations']);

  useEffect(() => {
    if (username) {
      setIsDisabeld(false);
    } else {
      setIsDisabeld(true);
    }
  }, [username]);

  const handleChange = (e: React.FocusEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setUsername(value);
  };

  const handleSubmit = () => {
    if (username) {
      setConfirmationSuccess(false);
      ApiService.forgotPassword(username)
        .then(() => {
          setConfirmationSuccess(true);
        })
        .catch(() => {
          setConfirmationSuccess(null);
          setError(true);
        });
    }
  };

  return (
    <Container className={classes.root}>
      <Paper className={classes.paper}>
        <Box className={classes.logoContainer}>
          <img src={logo} alt="Logo" className={classes.logo} />
        </Box>
        {confirmationSuccess ? (
          <div>
            <p>{t('forgot_password_page.request_success')}</p>
            <Link component={Button} href="/">
              {t('forgot_password_page.back_to_login')}
            </Link>
          </div>
        ) : confirmationSuccess === false ? (
          <CircularProgress color="secondary" className={classes.spinner} />
        ) : (
          <div className={classes.form}>
            <EmailTextInput
              required={true}
              label={t('login_page.email')}
              inputName="username"
              autoFocus={true}
              margin="normal"
              onChange={handleChange}
            />
            <Typography className={classes.error}>
              {error && t('forgot_password_page.request_failed')}
            </Typography>

            <Button
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              size="large"
              className={classes.submit}
              disabled={isDisabled}
            >
              {t('common.submit')}
            </Button>
          </div>
        )}
      </Paper>
    </Container>
  );
};

export { ForgotPassword };
